import React from 'react'

function Link({ source, name, handler, handleOut, handleOpen, tipData, title }) {
  return (
    <div>
      <a data={tipData} href={`#${name}`}
        className={`menuList ${source[name]}`}
        name={name}
        onMouseOver={handler}
        onMouseOut={handleOut}
        onClick={handleOpen}  >
        {title}</a>
    </div>

  )
}

export default Link
